<template>
  <BookingContainer />
</template>

<script lang="ts">
import Vue from "vue";
import BookingContainer from "@/components/projects/project/bookings/booking/container/BookingContainer.vue";

export default Vue.extend({
  components: {
    BookingContainer,
  },
});
</script>
